import * as React from "react";

const ReactIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      fill="#80deea"
      d="M24 34C11.1 34 1 29.6 1 24s10.1-10 23-10 23 4.4 23 10-10.1 10-23 10zm0-18c-12.6 0-21 4.1-21 8 0 3.9 8.4 8 21 8s21-4.1 21-8c0-3.9-8.4-8-21-8z"
    />
    <path
      fill="#80deea"
      d="M15.1 44.6c-1 0-1.8-.2-2.6-.7-4.9-2.8-3.6-13.7 2.8-24.9 3-5.2 6.7-9.6 10.3-12.4 3.9-3 7.4-3.9 9.8-2.5 2.5 1.4 3.4 4.9 2.8 9.8-.6 4.6-2.6 10-5.6 15.2-3 5.2-6.7 9.6-10.3 12.4-2.6 2-5.1 3.1-7.2 3.1zM32.9 5.4c-1.6 0-3.7.9-6 2.7C23.5 10.8 20 15 17.1 20c-6.3 10.9-6.9 20.3-3.6 22.2 1.7 1 4.5.1 7.6-2.3C24.5 37.2 28 33 30.9 28c2.9-5 4.8-10.1 5.4-14.4.5-4-.1-6.8-1.8-7.8-.5-.2-1-.4-1.6-.4z"
    />
    <path
      fill="#80deea"
      d="M33 44.6c-5 0-12.2-6.1-17.6-15.6C8.9 17.8 7.6 6.9 12.5 4.1 17.4 1.3 26.2 7.8 32.7 19c3 5.2 5 10.6 5.6 15.2.7 4.9-.3 8.3-2.8 9.8-.8.4-1.6.6-2.5.6zM13.5 5.8c-3.3 1.9-2.7 11.3 3.6 22.2 6.3 10.9 14.1 16.1 17.4 14.2 1.7-1 2.3-3.8 1.8-7.8-.6-4.3-2.5-9.4-5.4-14.4C24.6 9.1 16.8 3.9 13.5 5.8z"
    />
    <circle cx={24} cy={24} r={4} fill="#80deea" />
  </svg>
);

export default ReactIcon;
